// The local player's identity, stamped as the AUTHOR/OWNER of things you place (chests, baseclaims, doors). In
// single-player it's always 'local' so you own everything (nothing blocks you); networking will set the real id on
// join. The lock/access gate compares an object's owner against this -- a foreign-owned locked object is blocked.
export let LOCAL_PLAYER = 'local';
export function setLocalPlayer(id: string): void { LOCAL_PLAYER = id; }
